import React from "react";
import SEO from "../components/SEO";
import { LegalPage } from "../components/LegalPage";
import { PRIVACY_SECTIONS, LEGAL_UPDATED } from "../data/legal";

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Notice" description="How Cambridge Cardiovascular Clinic Ltd collects, uses and protects your personal and health information under UK GDPR." path="/privacy" />
      <LegalPage testId="privacy-page" eyebrow="Privacy notice" title="How we use your information." updated={LEGAL_UPDATED} sections={PRIVACY_SECTIONS} />
    </>
  );
}
